import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../types/RootState.js";
import { initialState } from "./slice.js";

const selectDomain = (state: RootState) => state.useMixpanel || initialState;

export const getMixpanelAuthenticated = createSelector([selectDomain], (useMixpanel) => useMixpanel?.authenticated);
